const dropdownUserTypes = [
  { value: 'admin', label: 'account.admin' },
  { value: 'requestor', label: 'account.requestor' },
  { value: 'purchaser', label: 'account.purchaser' },
  { value: 'super_admin', label: 'account.super_admin' },
]

export default dropdownUserTypes
